export enum OS {
  iOS = 'ios',
  Windows = 'windows',
  macOS = 'macos',
  web = 'web',
  Android = 'android',
}
